module.exports = __webpack_public_path__ + "static/media/mainPic.2837c154.svg";